import { render, staticRenderFns } from "./AccountantDossiers.vue?vue&type=template&id=0aca0a1c&scoped=true&"
import script from "./AccountantDossiers.vue?vue&type=script&lang=ts&"
export * from "./AccountantDossiers.vue?vue&type=script&lang=ts&"
import style0 from "./AccountantDossiers.vue?vue&type=style&index=0&id=0aca0a1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aca0a1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0aca0a1c')) {
      api.createRecord('0aca0a1c', component.options)
    } else {
      api.reload('0aca0a1c', component.options)
    }
    module.hot.accept("./AccountantDossiers.vue?vue&type=template&id=0aca0a1c&scoped=true&", function () {
      api.rerender('0aca0a1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AccountantDossiers.vue"
export default component.exports